"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _commonData = require("../../../../../Shared/store/commonData/commonData.selector");

var _ProductItem = require("../../../../../Marketplace/Products/components/ProductItem");

var _CampaignIcon = _interopRequireDefault(require("../../../../../Shared/Campaigns/components/CampaignIcon/CampaignIcon"));

var _FavouriteButton = _interopRequireDefault(require("../../../../../Shared/Campaigns/components/FavouriteButton/FavouriteButton"));

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var _features = require("../../../../../Shared/store/features");

var _BudgetBasedCampaignGridItem = require("./BudgetBasedCampaignGridItem.styles");

var _BudgetSettingsItem = _interopRequireDefault(require("./BudgetSettingsItem"));

var SButton = (0, _material.styled)('button')({});

var BudgetBasedCampaignGridItem = function BudgetBasedCampaignGridItem(_ref) {
  var _campaign$defaultProd;

  var campaign = _ref.campaign,
      measure = _ref.measure,
      expanded = _ref.expanded,
      onToggleExpand = _ref.onToggleExpand,
      onClick = _ref.onClick,
      onChangeIsFavourite = _ref.onChangeIsFavourite,
      availableBudgetForCampaign = _ref.availableBudgetForCampaign,
      isLoading = _ref.isLoading;
  (0, _react.useEffect)(function () {
    measure();
  }, [expanded, measure]);
  var multipleValues = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MULTIPLE_GIFT_CARD_VALUES));
  var countries = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    var _campaign$countryIds;

    return (0, _commonData.makeGetCountriesByIds)((_campaign$countryIds = campaign === null || campaign === void 0 ? void 0 : campaign.countryIds) !== null && _campaign$countryIds !== void 0 ? _campaign$countryIds : []);
  }, [campaign]));
  var trackCampaignsListDetailsToggled = (0, _useTrackGiftingFlow.useCampaignsListDetailsToggled)();
  var trackCampaignsListCampaignSelected = (0, _useTrackGiftingFlow.useCampaignsListCampaignSelected)();
  var handleDetailsClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();

    if (campaign !== null && campaign !== void 0 && campaign.id) {
      onToggleExpand(campaign.id);
      trackCampaignsListDetailsToggled({
        campaignId: campaign.id,
        isOpened: !expanded
      });
    }
  }, [campaign, onToggleExpand, expanded, trackCampaignsListDetailsToggled]);
  var handleCampaignClick = (0, _react.useCallback)(function (hasSufficientBudgetForCampaign) {
    if (campaign && hasSufficientBudgetForCampaign) {
      onClick(campaign);
      trackCampaignsListCampaignSelected({
        campaignId: campaign.id,
        campaignType: campaign.type
      });
    }
  }, [campaign, onClick, trackCampaignsListCampaignSelected]);

  if (!campaign || isLoading) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: _BudgetBasedCampaignGridItem.styles.root
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: _BudgetBasedCampaignGridItem.styles.header
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: _BudgetBasedCampaignGridItem.styles.skeletonContainer
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      sx: _BudgetBasedCampaignGridItem.styles.skeletonAvatar,
      variant: "circular"
    }), /*#__PURE__*/_react.default.createElement(_material.Box, {
      ml: 1
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: _BudgetBasedCampaignGridItem.styles.title
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      sx: _BudgetBasedCampaignGridItem.styles.skeletonTitle,
      variant: "text"
    })), /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: _BudgetBasedCampaignGridItem.styles.subtitle
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      sx: _BudgetBasedCampaignGridItem.styles.skeletonSubtitle,
      variant: "text"
    }))))), /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: _BudgetBasedCampaignGridItem.styles.footer
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      sx: _BudgetBasedCampaignGridItem.styles.skeletonFooter
    })));
  }

  var isPhysicalBudgetExists = typeof campaign.budgetSettings.minPrice === 'number' && typeof campaign.budgetSettings.maxPrice === 'number' && !multipleValues;
  var isGiftCardBudgetExists = typeof campaign.budgetSettings.giftCardPrice === 'number' && !multipleValues;
  var isDonationBidgetExists = typeof campaign.budgetSettings.donationPrice === 'number' && !multipleValues;
  var giftActionsValue = multipleValues && !!campaign.budgetSettings.recipientMarketplaceThreshold.label ? "Exchange value is ".concat(campaign.budgetSettings.recipientMarketplaceThreshold.label, " of the sent-gift cost") : "".concat(campaign.giftActions.exchange && 'Exchange').concat(campaign.giftActions.donate && ', Donate', " Allowed");
  var _campaign$budgetSetti = campaign.budgetSettings,
      minPrice = _campaign$budgetSetti.minPrice,
      maxPrice = _campaign$budgetSetti.maxPrice,
      giftCardPrice = _campaign$budgetSetti.giftCardPrice,
      donationPrice = _campaign$budgetSetti.donationPrice,
      donationMaxPrice = _campaign$budgetSetti.donationMaxPrice,
      donationMinPrice = _campaign$budgetSetti.donationMinPrice,
      giftCardMaxPrice = _campaign$budgetSetti.giftCardMaxPrice,
      giftCardMinPrice = _campaign$budgetSetti.giftCardMinPrice;
  var ranges = multipleValues ? [minPrice, maxPrice, donationMaxPrice, donationMinPrice, giftCardMaxPrice, giftCardMinPrice] : [minPrice, maxPrice, giftCardPrice, donationPrice];
  var definedRanges = [].concat(ranges).filter(function (range) {
    return range !== null;
  });
  var campaignMinGiftPrice = Math.min.apply(Math, (0, _toConsumableArray2.default)(definedRanges));
  var campaignMaxGiftPrice = Math.max.apply(Math, (0, _toConsumableArray2.default)(definedRanges));
  var hasSufficientBudgetForCampaign = availableBudgetForCampaign ? availableBudgetForCampaign >= campaignMinGiftPrice : false;
  var disabledStyles = hasSufficientBudgetForCampaign ? {} : _BudgetBasedCampaignGridItem.styles.disabledText;
  var TOOL_TIP_CONTENT = availableBudgetForCampaign ? 'You have insufficient budget to send gifts via this campaign. Please reach out to your team admin.' : 'Your team budget has not been configured. Please reach out to your team admin.';
  var TOOL_TIP_TITLE = hasSufficientBudgetForCampaign ? '' : TOOL_TIP_CONTENT;
  return /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    title: TOOL_TIP_TITLE,
    arrow: true,
    placement: "top"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [_BudgetBasedCampaignGridItem.styles.root, hasSufficientBudgetForCampaign && _BudgetBasedCampaignGridItem.styles.rootClickable],
    onClick: function onClick() {
      return handleCampaignClick(hasSufficientBudgetForCampaign);
    },
    "data-testid": "SelectCampaign.CampaignsGrid.".concat(campaign.name)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.header
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.headerTopContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.headerLeft
  }, /*#__PURE__*/_react.default.createElement(_CampaignIcon.default, {
    variant: campaign.type
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.campaignInfoContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [_BudgetBasedCampaignGridItem.styles.title, disabledStyles]
  }, campaign.name), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [_BudgetBasedCampaignGridItem.styles.subtitle, disabledStyles]
  }, campaign.owner.firstName, " ", campaign.owner.lastName, "\xA0|\xA0", campaign.team.name, "\xA0|\xA0", /*#__PURE__*/_react.default.createElement(_material.AvatarGroup, {
    sx: _BudgetBasedCampaignGridItem.styles.countries,
    total: Math.min(5, countries.length)
  }, countries.map(function (_ref2) {
    var name = _ref2.name,
        image = _ref2.image;
    return /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      key: name,
      alt: name,
      src: image
    });
  })), countries.length > 5 && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.additionalCountriesContainer
  }, "\xA0+", countries.length - 5)))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.headerRight
  }, /*#__PURE__*/_react.default.createElement(_FavouriteButton.default, {
    favourite: campaign.isFavourite,
    onClick: function onClick(event) {
      event.stopPropagation();
      onChangeIsFavourite(campaign.id, !campaign.isFavourite);
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.giftBudgetRange
  }, "Gift budget $", campaignMinGiftPrice, " - $", campaignMaxGiftPrice)))), expanded && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.details
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.campaignDataContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.innerDataContainer
  }, /*#__PURE__*/_react.default.createElement(_BudgetSettingsItem.default, {
    campaign: campaign,
    label: "Merchandise/Experiences",
    minPrice: campaign.budgetSettings.minPrice,
    maxPrice: campaign.budgetSettings.maxPrice
  }), /*#__PURE__*/_react.default.createElement(_BudgetSettingsItem.default, {
    campaign: campaign,
    label: "Gift cards",
    minPrice: campaign === null || campaign === void 0 ? void 0 : campaign.budgetSettings.giftCardMinPrice,
    maxPrice: campaign === null || campaign === void 0 ? void 0 : campaign.budgetSettings.giftCardMaxPrice
  }), /*#__PURE__*/_react.default.createElement(_BudgetSettingsItem.default, {
    campaign: campaign,
    label: "Donations",
    minPrice: campaign.budgetSettings.donationMinPrice,
    maxPrice: campaign.budgetSettings.donationMaxPrice
  }), isPhysicalBudgetExists && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Gift budget:"), " $", campaign.budgetSettings.minPrice, " - $", campaign.budgetSettings.maxPrice), isGiftCardBudgetExists && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Gift cards"), " $", campaign.budgetSettings.giftCardPrice), isDonationBidgetExists && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Donations"), " $", campaign.budgetSettings.donationPrice), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 1
  }, giftActionsValue), !!campaign.messageSubject && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Message:"), " ", campaign.messageSubject), !!campaign.sendAs && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Send As:"), " ", campaign.sendAs.firstName, " ", campaign.sendAs.lastName), !!campaign.campaignInstruction && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Campaign Instruction:"), " ", campaign.campaignInstruction)), !!(campaign !== null && campaign !== void 0 && (_campaign$defaultProd = campaign.defaultProducts) !== null && _campaign$defaultProd !== void 0 && _campaign$defaultProd.length) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.defaultGiftContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _BudgetBasedCampaignGridItem.styles.defaultGiftHeader
  }, "Default Gifts:"), campaign.defaultProducts.map(function (product) {
    return /*#__PURE__*/_react.default.createElement(_ProductItem.ConnectedTextProductItem, {
      key: product.id,
      sx: _BudgetBasedCampaignGridItem.styles.textEllipsis,
      id: product.id,
      denomination: product.denomination,
      hidePrice: true
    });
  })))), /*#__PURE__*/_react.default.createElement(SButton, {
    sx: [_BudgetBasedCampaignGridItem.styles.footer, disabledStyles],
    onClick: handleDetailsClick
  }, "Details", /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    sx: _BudgetBasedCampaignGridItem.styles.footerIcon,
    icon: expanded ? 'chevron-up' : 'chevron-down'
  }))));
};

var _default = BudgetBasedCampaignGridItem;
exports.default = _default;